
export const types = {
    admin: {
        SET_LIST: '[ADMIN] LIST ADMIN',
        SET_LIST_MOBILE: '[ADMIN] LIST ADMIN MOBILE',
        SET_HISTORY: '[ADMIN] LIST HISTORY ADMIN',
        SET_HISTORY_MOBILE: '[ADMIN] LIST HISTORY ADMIN MOBILE',
        SET_EVENT: '[ADMIN] LIST EVENTS ADMIN',
        SET_EVENT_MOBILE: '[ADMIN] LIST EVENTS ADMIN MOBILE',
        SET_VIEW: '[ADMIN] VIEW ADMIN',
    },
    pinsale: {
        SET_LIST: '[PINSALE] SET LIST',
        SET_EDIT: '[PINSALE] SET EDIT'
    },
    app: {
        SET_DATE: '[APP] SET DATE',
    },
    personal: {
        SET_PERSONAL_BONUSES: '[PERSONAL] SET PERSONAL BONUSES',
        SET_HISTORY_BONUSES: '[PERSONAL] SET HISTORY BONUSES',
    },
    bonuses: {
        SET_VIEW_BONUSES: '[BONUSES] SET VIEW BONUSES',
        SET_LIST: '[BONUSES] SET LIST BONUSES',
    },
    cashier: {
        SET_SHIFT: '[CASHIER] SET SHIFT',
        SET_USERS: '[CASHIER] SET USERS',
        SET_GROUPS: '[CASHIER] SET GROUPS',
        SET_GROUPS_MOBILE: '[CASHIER MOBILE] SET GROUPS',
        SET_DAYLI: '[CASHIER MOBILE] SET LIST',
        SET_SHIFT_MOBILE: '[CASHIER MOBILE] SET SHIFT',
        SET_GROUPS_VIEW_MOBILE: '[CASHIER MOBILE] SET GROUPS VIEW',
        SET_COUNT_GAMER_MOBILE: '[CASHIER MOBILE] COUNT GAMER',
        SET_GROUPS_VIEW: '[CASHIER] SET GROUPS VIEW',
        SET_GET_EVENT_HISTORY: '[CASHIER] SET GET EVENT HISTORY',
        SET_GAMER_LIST: '[CASHIER] SET GAMER LIST',
        SET_BET: '[CASHIER] SET BET',
        SET_OPERATOR_DETALIZATION: '[CASHIER] OPERATOR DETALIZATION',
        SET_COUNT_GAMER: '[CASHIER] COUNT GAMER',
        SET_LIST_CREDIT_HISTORY: '[CASHIER] SET LIST CREDIT HISTORY OPERATOR',
    },
    credit: {
        SET_LIST_CREDIT: '[CREDIT] SET LIST CREDIT',
        SET_LIST_GROUPS: '[CREDIT] SET LIST GROUPS',
        SET_CREDIT_LIVE: '[CREDIT] SET CREDIT LIVE',
        SET_LIST_CREDIT_HISTORY: '[CREDIT] SET LIST CREDIT HISTORY',
        SET_LIST_CREDIT_HISTORY_MOBILE: '[CREDIT MOBILE] SET LIST CREDIT HISTORY',
        SET_LIST_CREDIT_MOBILE: '[CREDIT MOBILE] SET LIST CREDIT',
        SET_LIST_GROUPS_MOBILE: '[CREDIT MOBILE] SET LIST GROUPS',
        SET_CREDIT_LIVE_MOBILE: '[CREDIT MOBILE] SET CREDIT LIVE',
    },
    exchangeRates: {
        SET_LIST_EXCHANGE_RATES: '[EXCHANGE_RATES] SET LIST',
        SET_VIEW_EXCHANGE_RATES: '[EXCHANGE_RATES] SET VIEW',
    },
    freespin: {
        SET_LIST_FREESPIN: '[FREESPIN] SET LIST FREESPIN',
        SET_LIST_GAME_FREESPIN: '[FREESPIN GAME] SET LIST GAME FREESPIN',
        SET_VIEW_GAME_FREESPIN: '[FREESPIN GAME] SET VIEW GAME FREESPIN',
    },
    information: {
        SET_USERS: '[INFORMATION] SET USERS',
        SET_SPIN: '[INFORMATION] SET SPIN',
        SET_DETALIZATION_SPIN: '[INFORMATION] SET DETALIZATION SPIN',
        SET_DETALIZATION: '[INFORMATION] SET DETALIZATION',
        SET_NEW_USERS: '[INFORMATION] SET NEW USERS',
        SET_COUNT_ONLINE: '[INFORMATION] SET COUNT ONLINE',
        SET_USERS_MOBILE: '[INFORMATION MOBILE] SET USERS',
        SET_SPIN_MOBILE: '[INFORMATION MOBILE] SET SPIN',
        SET_DETALIZATION_SPIN_MOBILE: '[INFORMATION MOBILE] SET DETALIZATION SPIN',
        SET_DETALIZATION_MOBILE: '[INFORMATION MOBILE] SET DETALIZATION',
        SET_NEW_USERS_MOBILE: '[INFORMATION MOBILE] SET NEW USERS',
        SET_COUNT_ONLINE_MOBILE: '[INFORMATION MOBILE] SET COUNT ONLINE',
    },
    jackpot: {
        SET_LIST_GROUP: '[JACKPOT] SET LIST GROUP',
        SET_LIST_JACKPOT: '[JACKPOT] SET LIST JACKPOT',
        SET_VIEW_JACKPOT: '[JACKPOT] SET VIEW JACKPOT',
        SET_LIST_GROUP_JACKPOT: '[JACKPOT] SET LIST GROUP JACKPOT',
        SET_HISTORY_LIST: '[JACKPOT HISTORY] SET HISTORY LIST',
    },
    lottery: {
        SET_LIST: '[LOTTERY] LIST LOTTERY',
        SET_VIEW: '[LOTTERY] VIEW LOTTERY',
        SET_ID: '[LOTTERY] ID LOTTERY',
        SET_STAT: '[LOTTERY] STAT LOTTERY',
        SET_PRIZE: '[LOTTERY] PRIZE',
        SET_WINNERS: '[LOTTERY] WINNERS',
    },
    messanger: {
        SET_LIST_MESSANGER: '[MESSANGER] SET LIST MESSANGER',
        SET_VIEW_MESSANGER: '[MESSANGER] SET VIEW MESSANGER',
    },
    referrals: {
        SET_AMOUNT: '[REFERRALS] SET AMOUNT',
        SET_REFERRALS: '[REFERRALS] SET REFERRALS',
        SET_REFERRAL_INFO: '[REFERRALS] SET REFERRAL INFO',
    },
    ggr: {
        SET_GGR: '[GGR] SET GGR',
        SET_OPERATION_REPLENISHMENT: '[GGR] SET OPERATIONS REPLENISHMENT',
        SET_OPERATION_WITHDRAWAL: '[GGR] SET OPERATIONS WITHDRAWAL',
    },
    daily: {
        SET_LIST: '[DAILY] SET LIST',
        SET_VIEW: '[DAILY] SET VIEW',
        SET_LOGIN: '[DAILY] SET LOGIN',
    },
    tournament: {
        SET_LIST: '[TOURNAMENT] SET LIST',
        SET_VIEW: '[TOURNAMENT] SET VIEW',
        SET_LIST_STAT: '[TOURNAMENT] SET LIST STAT',
        SET_SEARCH_GAME: '[TOURNAMENT] SET SEARCH GAME',
    },
    users: {
        SET_USERS_LIST_MOBILE: '[USERS MOBILE] SET USERS LIST',
        SET_USER_BY_ID_MOBILE: '[USERS MOBILE] SET USER BY ID',
        SET_REZYME_MOBILE: '[USERS MOBILE] SET REZYME',
        SET_LAST_OPERATION_MOBILE: '[USERS MOBILE] SET LAST OPERATION',
        SET_REPLENISHMENT_USER_MOBILE: '[USERS MOBILE] SET REPLENISHMENT USER',
        SET_WITHDRAWALS_USER_MOBILE: '[USERS MOBILE] SET WITHDRAWALS USER',
        SET_BONUSES_HISTORY_MOBILE: '[USERS MOBILE] SET BONUSES HISTORY',
        SET_HISTORY_LIST_MOBILE: '[USERS MOBILE] SET HISTORY LIST',
        SET_HISTORY_LIST: '[USERS] SET HISTORY LIST',
        SET_JACKPOT_MOBILE: '[USERS MOBILE] SET JACKPOT',
        SET_USERS_LIST: '[USERS] SET USERS LIST',
        SET_USER_BY_ID: '[USERS] SET USER BY ID',
        SET_WITHDRAWALS_USER: '[USERS] SET WITHDRAWALS USER',
        SET_WITHDRAWALS: '[USERS] SET WITHDRAWALS',
        SET_REPLENISHMENT_USER: '[USERS] SET REPLENISHMENT USER',
        SET_HISTORY_GAMES_USER: '[USERS] SET HISTORY GAMES USER',
        SET_BONUSES_HISTORY: '[USERS] SET BONUSES HISTORY',
        SET_LAST_OPERATION: '[USERS] SET LAST OPERATION',
        SET_REZYME: '[USERS] SET REZYME',
        SET_VERIFICATION: '[USERS] SET VERIFICATION',
        SET_FREESPIN_OPERATION: '[USERS] SET FREESPIN OPERATION',
        SET_USER_LOGGER: '[USERS] SET USER LOGGER',
        SET_USER: '[USER] SET USER',
        SET_HISTORY_REPLENISHMENT: '[USER] SET HISTORY REPLENISHMENT',
        SET_HISTORY_WITHDRAWALS: '[USER] SET HISTORY WITHDRAWALS',
        SET_USERS: '[USERS] SET USERS',
        SET_SEARCH_USERS_LIST: '[SEARCH USERS] SET USERS LIST',
        SET_GAMES_LIST: '[USERS] SET GAMES LIST'
    },
    support: {
        SET_SUPPORT_LIST: '[SUPPORT] SET SUPPORT LIST',
        SET_SUPPORT_LIST_MOBILE: '[SUPPORT] SET SUPPORT LIST MOBILE',
        SET_SUPPORT_VIEW: '[SUPPORT] SET SUPPORT VIEW',
        SET_SUPPORT_VIEW_MOBILE: '[SUPPORT] SET SUPPORT VIEW MOBILE'
    },
    report: {
        SET_HISTORY_LIST: '[REPORT] SET HISTORY LIST',
        SET_HISTORY_LIST_MOBILE: '[REPORT] SET HISTORY LIST MOBILE',
        SET_CASHIERS_PROFILE: '[REPORT] SET CASHIERS PROFILE',
        SET_CASHIERS_PROFILE_MOBILE: '[REPORT] SET CASHIERS PROFILE MOBILE',
        SET_HISTORY_JACKPOT: '[REPORT] SET HISTORY JACKPOT',
        SET_HISTORY_JACKPOT_MOBILE: '[REPORT] SET HISTORY JACKPOT MOBILE',
        SET_HISTORY_BONUSES: '[REPORT] SET HISTORY BONUSES',
        SET_HISTORY_BONUSES_MOBILE: '[REPORT] SET HISTORY BONUSES MOBILE',
        SET_REPLENISHMENT_REPORT: '[REPLENISHMENT REPORT] SET REPLENISHMENT REPORT',
        SET_HISTORY_LIST_BONUSES: '[REPORT BONUSES] SET HISTORY LIST',
        SET_GGR_MOBILE: '[REPORT] SET GGR MOBILE',
        SET_OPERATION_REPLENISHMENT_MOBILE:'[REPORT] SET OPERATION REPLENISHMENT MOBILE',
        SET_OPERATION_WITHDRAWAL_MOBILE:'[REPORT] SET OPERATION WITHDRAWAL MOBILE'

    },
    provider: {
        SET_PROVIDER_LIST: '[PROVIDER] SET PROVIDER LIST',
        SET_SEARCH_LIST: '[PROVIDER] SET SEARCH LIST',
        SET_CARD_OPERATION: '[PROVIDER] SET CARD OPERATION LIST',
    },
    replenishment: {
        SET_LIST: '[PAYMENT] SET LIST',
        SET_LIST_MOBILE: '[PAYMENT] SET LIST MOBILE',
        SET_REPLENISHMENT: '[REPLENISHMENT] SET REPLENISHMENT',
        SET_SHIFT_MOBILE: '[REPLENISHMENT] SET SHIFT MOBILE',
        SET_REPLENISHMENT_REPORT_MOBILE: '[REPLENISHMENT] SET REPLENISHMENT REPORT MOBILE',
        SET_REPLENISHMENT_MOBILE: '[REPLENISHMENT] SET REPLENISHMENT MOBILE'
    },
    common: {
        SET_LIST: '[KYC] SET LIST',
        SET_LIST_MOBILE: '[KYC MOBILE] SET LIST',
        SET_LIST_ORGANIZATION: '[OBJECT] SET LIST ORGANIZATION',
        SET_GET_PRESENT: '[PRESENT] SET GET PRESENT',
        SET_VIEW_KEYS: '[QIWI] SET VIEW KEYS',
        SET_HISTORY_LIST: '[HISTORY] SET HISTORY LIST',
        SET_GAMES_LIST: '[GAMES] SET GAMES FS',
        SET_WITHDRAWALS: '[WITHDRAWALS] SET WITHDRAWALS',
        SET_WITHDRAWALS_MOBILE: '[WITHDRAWALS] SET WITHDRAWALS MOBILE',
        SET_LOADING: '[ADMIN] LOADING',
    },
    auth: {
        SET_AUTHORIZE: '[AUTH] SET AUTHORIZE',
        SET_ADMIN: '[AUTH] SET ADMIN'
    },
    categories: {
        SET_CATEGORIES_LIST: '[CATEGORIES] SET CATEGORIES LIST',
        SET_CASHIERS_PROFILE: '[CATEGORIES] SET CASHIERS PROFILE',
    }
}